import React, { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
import "../assets/css/CustomSelect.css";

const CustomSelect = ({ options = [], value, onChange, disabled = false, className = "" }) => {
  const [open, setOpen] = useState(false);
  const [menuStyle, setMenuStyle] = useState({});
  const triggerRef = useRef(null);
  const menuRef = useRef(null);

  const selected = options.find((o) => o.value === value) || options[0];

  const openMenu = () => {
    if (disabled) return;
    const rect = triggerRef.current?.getBoundingClientRect();
    if (rect) {
      setMenuStyle({
        position: "fixed",
        top: rect.bottom + 4,
        left: rect.left,
        width: rect.width,
        zIndex: 9999,
      });
    }
    setOpen((p) => !p);
  };

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (
        triggerRef.current && !triggerRef.current.contains(e.target) &&
        menuRef.current && !menuRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  // Close on scroll/resize to avoid stale position
  useEffect(() => {
    if (!open) return;
    const close = () => setOpen(false);
    window.addEventListener("scroll", close, true);
    window.addEventListener("resize", close);
    return () => {
      window.removeEventListener("scroll", close, true);
      window.removeEventListener("resize", close);
    };
  }, [open]);

  const handleSelect = (opt) => {
    onChange(opt.value);
    setOpen(false);
  };

  return (
    <>
      <div
        ref={triggerRef}
        className={`csel-wrap${open ? " csel-open" : ""}${disabled ? " csel-disabled" : ""} ${className}`}
      >
        <button
          type="button"
          className="csel-trigger"
          onClick={openMenu}
          disabled={disabled}
        >
          <span className="csel-value">{selected?.label}</span>
          <ChevronDown size={14} className="csel-arrow" />
        </button>
      </div>

      {open && (
        <div ref={menuRef} className="csel-menu" style={menuStyle}>
          {options.map((opt) => (
            <button
              key={opt.value}
              type="button"
              className={`csel-option${opt.value === value ? " csel-selected" : ""}`}
              onClick={() => handleSelect(opt)}
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </>
  );
};

export default CustomSelect;
